<div class="app-sub-header">
  <button class="btn btn-styleless subheader-button"
          (click)="downloadPlanGuide()"
          pTooltip="Download Guidebook"
          tooltipPosition="bottom"
          appendTo="target">
    <img class="book-icon" src="assets/images/download-guide-icon-white.svg" alt="Resources">
  </button>
  <button class="btn btn-styleless subheader-button"
          (click)="goToResources()"
          pTooltip="Resources and Information"
          tooltipPosition="bottom"
          appendTo="target">
    <img class="book-icon" src="assets/images/resources-white.svg" alt="Information">
  </button>
</div>
